import { DocumentPlusIcon } from '@heroicons/react/24/outline';
import { useMatch } from '@tanstack/react-router';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { AiMenuItem } from '@/shared/ui';
import type { AIContextMenu } from '@/widgets/right-side-menu/lib/types';
import { CreateFromPdfMode } from './create-from-pdf/CreateFromPdfMode';

type Props = {
  aiContextMenu: undefined | AIContextMenu;
  setAiContextMenu: (context: undefined | AIContextMenu) => void;
};
export const ProjectCreateAIChatContents: FC<Props> = ({ aiContextMenu, setAiContextMenu }) => {
  const { t } = useTranslation();

  // フックはすべて早期returnの前に呼ぶ
  const isEditPage = useMatch({
    from: '/_protected/projects/$projectId/edit',
    shouldThrow: false,
  });

  const isCreateFromPdfMode =
    (aiContextMenu?.route === 'projectCreate' || aiContextMenu?.route === 'projectEdit') &&
    aiContextMenu?.mode === 'createFromPdf';

  if (isCreateFromPdfMode) {
    return <CreateFromPdfMode mode={isEditPage ? 'edit' : 'create'} />;
  }

  return (
    <AiMenuItem
      menuTitle={isEditPage ? t('ai.update-from-pdf.title') : t('ai.create-from-pdf.title')}
      description={t('ai.create-from-pdf.description')}
      icon={<DocumentPlusIcon className="text-text-accent" />}
      onClick={() =>
        setAiContextMenu({
          route: isEditPage ? 'projectEdit' : 'projectCreate',
          mode: 'createFromPdf',
        })
      }
    />
  );
};
